import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { UpdateContactTitleComponent } from './update-contact-title/update-contact-title.component'
import { ContactTitlesComponent } from './contact-titles.component'
import { CreateContactTitleComponent } from './create-contact-title/create-contact-title.component'
import { contactTitlesRoutes } from './contact-titles.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    ContactTitlesComponent,
    CreateContactTitleComponent,
    UpdateContactTitleComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(contactTitlesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    ContactTitlesComponent,
    CreateContactTitleComponent,
    UpdateContactTitleComponent,
  ],
})
export class ContactTitlesModule {}
